/// <amd-module name="DistributedTaskUI/SecurityComponent/ProjectPermissionsAuthorization/Source/ProjectAuthorizationSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { ServiceEndpoint, ServiceEndpointProjectReference, ServiceEndpointActionFilter } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { IServiceEndpointRestClient } from "ServiceEndpoints/Client/RestClient/ServiceEndpoint";
import { ICoreRestClient } from "Tfs/Platform/RestClient/Core";
import { ProjectState, TeamProjectReference } from "Tfs/Platform/Contracts/Core";

export class ProjectAuthorizationSource {
    constructor(_pageContext: IVssPageContext, projectId: string) {
        this._restClient = _pageContext.getRestClient<ICoreRestClient>("ICoreRestClient");
        this._serviceEndpointRestClient = _pageContext.getRestClient<IServiceEndpointRestClient>("ServiceEndpoint.IServiceEndpointRestClient");
        this._projectId = projectId;
    }

    public getProjectsData(): Promise<TeamProjectReference[]> {
        return this._restClient.getProjects(ProjectState.WellFormed, null, null, null, true);
    }

    public getServiceEndpointDetails(endpointId: string): Promise<ServiceEndpoint> {
        return this._serviceEndpointRestClient.getServiceEndpointDetails(this._projectId, endpointId, ServiceEndpointActionFilter.View);
    }

    public deleteProjectReference(endpoint: ServiceEndpoint, projectIds: string[]): Promise<void> {
        return this._serviceEndpointRestClient.deleteServiceEndpoint(endpoint.id, projectIds);
    }

    public addProjectReference(endpoint: ServiceEndpoint, projectReferences: ServiceEndpointProjectReference[]): Promise<void> {
        return this._serviceEndpointRestClient.shareServiceEndpoint(projectReferences, endpoint.id);
    }

    private _serviceEndpointRestClient: IServiceEndpointRestClient;
    private _projectId: string;
    private _restClient: ICoreRestClient;
}